import * as React from 'react'

import { Form as FactorialForm } from 'factorial-form'
import uniq from 'lodash/uniq'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import type Complaint from 'modules/complaints/store/models/Complaint'

export class ComplaintsFilters extends FactorialForm {
  constructor(values: {}) {
    super(values, {
      status: 'string',
    })
  }
}
interface Props {
  complaints: Complaint[]
  filtersForm: ComplaintsFilters
  onFilterChange: () => void
}

const Options = observer(({ complaints, filtersForm, onFilterChange }: Props) => {
  const labels: Record<string, string> = {
    acknowledged: i18n.t('complaints.status.in_progress'),
    created: i18n.t('complaints.status.created'),
    completed: i18n.t('complaints.status.processed'),
    discarded: i18n.t('complaints.status.discarded'),
  }

  const statuses = complaints.map((complaint) => complaint.status)
  const uniqueStatuses = uniq(statuses)

  const options = uniqueStatuses.map((status) => ({
    value: status,
    label: labels[status] ?? '',
  }))

  return (
    <Select
      label={i18n.t('complaints.table.filters.status.label')}
      field={filtersForm.get('status')}
      options={options}
      none={i18n.t('complaints.table.filters.status.default')}
      onChange={onFilterChange}
    />
  )
})

export default Options
